import type { HubspotIntegrationConfiguration } from '@vy/types';
import { INTEGRATION_PROVIDERS } from '@vy/types';
import type { DeepPartial } from 'react-hook-form';
import type { HubSpotConfigurationFormValues } from '../HubSpotConfigurationFormSchema';

export function getHubSpotIntegrationSettings(configuration: HubSpotConfigurationFormValues) {
  return {
    integrationProvider: INTEGRATION_PROVIDERS.hubspot,
    integrationConfiguration: mapFormValuesToHubSpotSettings(configuration),
  };
}

function mapFormValuesToHubSpotSettings(
  formValues: HubSpotConfigurationFormValues,
): DeepPartial<HubspotIntegrationConfiguration> {
  return {
    autoImportCustomers: formValues.autoImportCustomers,
    autoImportContracts: formValues.autoImportContracts,
  };
}
